"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.log = void 0;
var log_1 = require("@slavshik/log");
if (process.env.NODE_ENV === "development") {
    log_1.log.setLevel(Number.MAX_SAFE_INTEGER);
}
else {
    log_1.log.setLevel(3);
}
var log = log_1.log.scope("#dp");
exports.log = log;
//# sourceMappingURL=log.js.map